import TeacherLeaveCreate from "@/controllers/teacher_leave/leave-create.js";

export default {
  extends: TeacherLeaveCreate,
  data() {
    return {
      leaveData: {
        employee_id: this.auth('teacher').user()?.employee_id,
        period: [],
        from_date: null,
        to_date: null,
        remark: null,
        status: null,
        leave_images: [],
        selected_leave_type: null
      },
    };
  }
};
